<template>
  <div>
    <van-dropdown-menu title="123" ref="dropdownitems">
      <van-dropdown-item title="搜单词" ref="item">
        <van-cell center title="单词">
          <template #right-icon>
            <van-search v-model="valueWord" placeholder="请输入搜索单词" />
          </template>
        </van-cell>
        <div style="padding: 5px 16px;">
          <van-button type="danger" block round @click="onConfirmWord">
            确认
          </van-button>
        </div>
      </van-dropdown-item>
      <van-dropdown-item title="搜短语" ref="item">
        <van-cell center title="词组">
          <template #right-icon>
            <van-search v-model="valueExpression" placeholder="请输入搜索词组" />
          </template>
        </van-cell>
          <van-field
              left-icon=""
              v-model="textbookValue"
              is-link
              readonly
              label=""
              placeholder="点击选择教材（默认选中所有教材）"
              type="textarea"
              @click="gobackTextbook()"
          />
          <van-popup v-model="showPickerTextbook" round position="bottom" :style="{ height: '60%' }">
            <van-nav-bar
                title="选择教材"
                left-text="返回"
                right-text=""
                left-arrow
                @click-left="showPickerTextbook=false"
                @click-right=""
            />
            <van-row type="flex" justify="space-between">
              <van-col span="">
                <van-button type="default" size="normal" @click="textbookOnConfirm">确定</van-button>
              </van-col>
              <van-col span="">
                <van-button type="default" size="normal" @click="clearTextbookSelected">清空</van-button>
              </van-col>
            </van-row>
            <van-checkbox-group v-model="textbookSelected">
              <van-cell-group>
                <van-cell
                    v-for="(textbook, index) in textbookColumns"
                    clickable
                    :key="textbook"
                    :title="`${textbook}`"
                    @click="toggleTextbook(index)"
                >
                  <template #right-icon>
                    <van-checkbox :name="textbook" ref="checkboxes"/>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </van-popup>

        <div style="padding: 5px 16px;">
          <van-button type="primary" block round @click="onConfirmExpression">
            确认
          </van-button>
        </div>
      </van-dropdown-item>
    </van-dropdown-menu>

  </div>
</template>

<script>
import {Toast} from "vant";

export default {
  name: "wordSelect",
  data(){
    return {
      valueWord: '',
      valueExpression: '',
      showPickerTextbook: false,
      textbookValue: '',
      textbookColumns: ['新七上', '新七下', '新八上', '七上', '七下','八上', '八下', '九上', '九下', '必修一', '必修二', '必修三', '选修一', '选修二', '选修三'],
      textbookSelected: [],
    }
  },
  methods: {
    // 收起dropdown
    foldDropdown(index){
      this.$refs.dropdownitems.children[index].toggle()
    },
    // 搜索单词
    onConfirmWord() {
      this.$yesnoFilter()
      let resultWord = [];
      if(this.judgeEnglish(this.valueWord)=='英文'){
        for(let i=0;i<this.$store.state.newWords.length;i++){
          if(this.$store.state.newWords[i]['英文'].includes(this.valueWord.toString()) &&
              this.$store.state.newWords[i]['备注'].indexOf('词组') == -1){
            resultWord.push(this.$store.state.newWords[i])
          }
        };
      }else{
        for(let i=0;i<this.$store.state.newWords.length;i++){
          if(this.$store.state.newWords[i]['中文'].indexOf(this.valueWord) != -1 &&
              this.$store.state.newWords[i]['备注'].indexOf('词组') == -1)
          {
            resultWord.push(this.$store.state.newWords[i])
          }
        }
      }
      // console.log('resultWord', resultWord)
      this.valueWord = '';
      this.$store.state.filterResult  = this.sortExpression(resultWord);

      if(resultWord.length != 0){
        let res = new Promise((resolve, reject) => {
          this.foldDropdown(0)
          resolve('ok')
        })
        res.then( res => {
          this.$router.push({ name: 'wordsList', params: {
            }});
        })
      }else{
        Toast.fail('未找到')
      }

    },
    // 搜索词组
    onConfirmExpression(){
      this.$yesnoFilter(); // 判断网络
      let resultExpression = [];
      // if(this.judgeEnglish(this.valueExpression)=='英文'){
      //   // console.log('英文')
      //   // 分三种情况 开头，结尾，中间  take |^take | take$
      //   const patten1 = new RegExp(' ' + this.valueExpression + ' |^' + this.valueExpression + ' | ' + this.valueExpression + '$');
      //   for(let i=0;i<this.$store.state.newWords.length;i++){
      //     if( patten1.test(this.$store.state.newWords[i]['英文']) == true &&
      //         this.$store.state.newWords[i]['备注'].indexOf('词组') != -1){
      //       resultExpression.push(this.$store.state.newWords[i])
      //       // resultExpression.push(this.$store.state.newWords[i]['英文'])
      //     }
      //   };
      // }else{
      //   // console.log('中文')
      //   for(let i=0;i<this.valueExpression.length;i++){
      //     for(let j=0;j<this.$store.state.newWords.length;j++){
      //       if(this.$store.state.newWords[j]['备注'].indexOf('词组') != -1){
      //         // console.log(this.$store.state.newWords[j]['英文'], )
      //         if(this.$store.state.newWords[j]['中文'].includes(this.valueExpression[i]) ||
      //             this.$store.state.newWords[j]['词性'].includes(this.valueExpression[i])
      //         ){
      //           resultExpression.push(this.$store.state.newWords[j]);
      //         }
      //       }
      //     }
      //   }
      // }
      const textbookColumns = this.textbookColumns;

      function getResultExpression(searchValue, books, newWords){
        books = (books => {
          if(books.length==0){
            return textbookColumns
          }else{
            return books
          };
        })(books);
        const judgeEnglish = value => {
          const regList = [
              {'reg':/[\u4E00-\u9FA5]/, 'name':'中文'},
              {'reg':/[^0-9]/, 'name':'英文'},
              {'reg':/[^A-Za-z]/, 'name':'数字'},
          ];
          for (let i=0; i<regList.length; i++) {
            if (regList[i].reg.test(value)) return regList[i].name;
          };
        };
        const key = judgeEnglish(searchValue);
        // console.log(books, key);
        if(searchValue==''){
          for(let item of newWords) {
            for (let book of books) {
              if(item['备注'].indexOf('词组') != -1 && item['教材'].includes(book)){
                resultExpression.push(item);
              }
            }
          }
          return resultExpression
        };
        if(key == '英文'){
          const patten1 = new RegExp(' ' + searchValue + ' |^' + searchValue + ' | ' + searchValue + '$');
          for(let item of newWords) {
            for (let book of books) {
              // console.log(item, book)
              if(patten1.test(item['英文']) == true && item['备注'].indexOf('词组') != -1 && item['教材'].includes(book)){
                resultExpression.push(item);
              }
            }
          }
        }else{
          for(let item of newWords) {
            for(let i of searchValue){
              for(let book of books) {
                if((item['中文'].includes(i) || item['词性'].includes(i)) && item['备注'].indexOf('词组') != -1 && item['教材'].includes(book)){
                  resultExpression.push(item);
                }
              }
            }
          }
        };
        return resultExpression
      }

      resultExpression = getResultExpression(this.valueExpression, this.textbookSelected, this.$store.state.newWords);
      // console.table('resultExpression', resultExpression);
      resultExpression = this.sortExpression(resultExpression);
      resultExpression = this.uniqueArr(resultExpression);
      this.valueExpression = '';
      // console.log('resultExpression', resultExpression)
      this.$store.state.filterResult  = resultExpression;
      if(resultExpression.length != 0){
        let res = new Promise((resolve, reject) => {
          this.clearTextbookSelected();
          this.foldDropdown(1);
          resolve('ok')
        })
        res.then( res => {
          this.$router.push({ name: 'wordsList', params: {
            typeShow: 'expression',
            }});
        })
      }else{
        Toast.fail('未找到');
      }
    },
    // 选择词组教材
    textbookOnConfirm(){
      this.showPickerTextbook = false;
      if(this.textbookSelected.length != 0){
        function getTextbookValue(textbookList) {
          const textbookLength = textbookList.length;
          if(textbookLength <= 3){
            return '已选：'+ textbookList.toString()
          }else{
            return '已选：'+ textbookList[0] + ',' + textbookList[1] + '等' +  textbookLength + '本书'
          }
        };
        this.textbookValue = getTextbookValue(this.textbookSelected);
      };
    },
    clearTextbookSelected(){
      this.textbookSelected = [];
      this.textbookValue = '';
    },
    toggleTextbook(index){
      this.$refs.checkboxes[index].toggle();
    },
    gobackTextbook(){
      this.showPickerTextbook = true;
      this.clearTextbookSelected();
    },
    // 判断英文还是中文
    judgeEnglish(value){
      const regList = [
        {'reg':/[\u4E00-\u9FA5]/, 'name':'中文'},
        {'reg':/[^0-9]/, 'name':'英文'},
        {'reg':/[^A-Za-z]/, 'name':'数字'},
      ];
      for (let i=0; i<regList.length; i++) {
        if (regList[i].reg.test(value)) return regList[i].name;
      }
    },
    // 单词词组排序
    sortExpression(_arr){
      // 字典自定义排序
      let sortArr1 = ['新七上', '新七下', '新八上', '七上','七下','八上','八下','九上','九下','必修一','必修二','必修三','选修一', '选修二'];
      let sortArr2 = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
      function getIndex(arr, key){
        return arr.indexOf(key) != -1 ? arr.indexOf(key) : 10000;
      }
      _arr.sort(function(a,b){
        if (getIndex(sortArr1, a.教材) == getIndex(sortArr1, b.教材)) {
          try{
            if (getIndex(sortArr2, a.模块.split(' ')[1]) > getIndex(sortArr2, b.模块.split(' ')[1])) {
              return 1
            } else if (getIndex(sortArr2, a.模块.split(' ')[1]) < getIndex(sortArr2, b.模块.split(' ')[1])) {
              return -1
            } else {
              return 0
            }
          }catch (e) {
            return
          }
        } else {
          return getIndex(sortArr1, a.教材) > getIndex(sortArr1, b.教材) ? 1 : -1
        }
      });
      // console.log(_arr);
      return _arr
    },
    // 数组去重复
    uniqueArr(arr){
      let hash=[];
      for (let i = 0; i < arr.length; i++) {
        if(hash.indexOf(arr[i])==-1){
          hash.push(arr[i]);
        }
      }
      return hash;
    },
  },
  mounted() {
  },
  activated() {

  }
}
</script>

<style scoped>

</style>